import React, { useContext } from "react";
import TextInput from "components/FormElements/TextInput";
import Label from "components/FormElements/Label";
import { ContainerContext } from "context/Container";
import { toast } from "react-hot-toast";

function UuidField(props) {
    const { state } = useContext(ContainerContext);

    const requestClipboardWrite = (data) => {
        navigator.clipboard.writeText(data).then(() => {
            toast.success("Copied UUID to clipboard");
        });
    };
    if (state.loading) {
        return (
            <div>
                <Label>UUID</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <div className="flex items-end">
            <div className="flex-grow">
                <TextInput
                    name="uuid"
                    id="uuid"
                    label="UUID"
                    readOnly
                    disabled={state.loading || state.preformingStateUpdate}
                />
            </div>
            <button
                type="button"
                onClick={requestClipboardWrite.bind(
                    null,
                    state.container && state.container.uuid
                        ? state.container.uuid
                        : ""
                )}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="m-2 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                    />
                </svg>
            </button>
        </div>
    );
}

export default UuidField;
